<template>
  <PageContainer>
    <div class="credito-content">
      <!-- Seção de Filtros e Créditos -->
      <div class="filtros-section card mb-4">
        <div v-if="!mostrarSelectAutoescola" class="filtros-header d-flex flex-wrap align-items-center justify-content-between mb-3">
          <div class="creditos-info d-flex align-items-center gap-3" :key="saldo.id" v-for="saldo in saldos">
            <div>
              <div class="creditos-label">Créditos Disponíveis: {{ saldo.credito.descricao }}</div>
              <div class="creditos-valor">{{ saldo.saldo }} NC</div>
              <!-- <div class="creditos-status">
                <i class="fa fa-arrow-up text-success"></i>
                <span class="text-success">0% Última semana</span>
              </div> -->
            </div>
          </div>
          <Button text="Comprar Créditos" color="primary" size="small" class="ml-3" @handle:click="abrirModalCompra" />
        </div>
        <Modal ref="modalCompra" @close="fecharModalCompra" title="Comprar Créditos" width="800px">
          <Compras :saldos="saldos" @compra-finalizada="onCompraFinalizada"/>
        </Modal>
        <template v-if="isFinanceiro">
          <div class="filtros-header d-flex flex-wrap align-items-center justify-content-between mb-3">
            <div class="creditos-label">Concessão de créditos para autoescolas e autônomos</div>
            <Button text="Conceder créditos" color="primary" size="small" @handle:click="abrirModalConcessao" />
          </div>
          <Modal ref="modalConcessao" title="Conceder créditos" width="640px" force>
            <ConcederCreditos
              ref="concederCreditos"
              :cfcOptions="cfcOptionsConcessao"
              @cancelar="fecharModalConcessao"
              @concedido="onConcessaoRealizada"
            />
          </Modal>
        </template>
        <div class="row g-3 align-items-center">
          <div class="col-12 mb-3 mt-4">
            <div class="radio-group">
              <label class="radio-label">
                <input
                  type="radio"
                  value="transacoes"
                  v-model="visualizacaoAtiva"
                  :disabled="carregando || carregandoCompra"
                />
                <span>Transações</span>
              </label>
              <label class="radio-label">
                <input
                  type="radio"
                  value="compras"
                  v-model="visualizacaoAtiva"
                  :disabled="carregando || carregandoCompra"
                />
                <span>Compras</span>
              </label>
              <label v-if="isFinanceiro" class="radio-label">
                <input
                  type="radio"
                  value="concessoes"
                  v-model="visualizacaoAtiva"
                  :disabled="carregando || carregandoCompra"
                />
                <span>Concessões</span>
              </label>
            </div>
          </div>
          <div class="col-12 col-md-3 mt-4">
            <InputDate
              :modelValue="filtros.dataInicio"
              @update:modelValue="filtros.dataInicio = $event"
              :disabled="carregando"
            />
          </div>
          <div class="col-12 col-md-3 mt-4">
            <InputDate
              :modelValue="filtros.dataFim"
              @update:modelValue="filtros.dataFim = $event"
              :disabled="carregando"
            />
          </div>
          <div class="col-12 col-md-3" v-if="visualizacaoAtiva === 'transacoes'">
            <Select
              :modelValue="filtros.tipo"
              @update:modelValue="filtros.tipo = $event"
              legend="Tipo de Transação"
              :options="opcoesTipo"
              placeholder="Selecione o tipo"
              :disabled="carregando"
            />
          </div>
          <div class="col-12 col-md-3" v-if="mostrarSelectAutoescola">
            <Select
              :modelValue="schema"
              @update:modelValue="schema = $event"
              legend="Autoescola"
              :options="schemaOptions"
              placeholder="Selecione"
              :disabled="carregando"
            />
          </div>
          <div class="col-12 col-md-3" v-if="visualizacaoAtiva === 'transacoes'">
            <Input
              type="text"
              :modelValue="filtros.renach"
              @update:modelValue="filtros.renach = $event"
              legend="Renach"
              placeholder="Informe o RENACH"
              :disabled="carregando"/>
          </div>
          <div class="col-12 col-md-3" v-if="visualizacaoAtiva === 'compras'">
            <Input
              type="text"
              :modelValue="filtros.nossoNumero"
              @update:modelValue="filtros.nossoNumero = $event"
              legend="Nosso Número"
              placeholder="Informe o Nosso Número"
              :disabled="carregando"/>
          </div>
          <div class="col-12 mt-4 d-flex justify-content-end align-items-center filtros-actions">
            <Button text="Filtrar" color="primary" @handle:click="filtrarTransacoes" :disabled="carregando" />
            <Button text="Limpar" color="secondary" :fill="false" @handle:click="limparFiltros" :disabled="carregando" class="ml-2" />
            <div class="ml-2" v-if="visualizacaoAtiva !== 'concessoes'">
              <Button text="Exportar" color="primary" icon="fa fa-download" :disabled="carregando" />
              <vuestic-dropdown position="bottom" class="export-dropdown">
                <div class="dropdown-export-row">
                  <button type="button" class="btn-export" @click="exportarRelatorio('pdf')">
                    <i class="fa fa-file-pdf-o" style="margin-right: 6px;"></i> PDF
                  </button>
                  <button type="button" class="btn-export" @click="exportarRelatorio('csv')">
                    <i class="fa fa-file-excel-o" style="margin-right: 6px;"></i> CSV
                  </button>
                </div>
              </vuestic-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabela Unificada: Compras ou Transações -->
      <div class="transacoes-section card">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h4 class="mb-0">{{ tituloTabela }}</h4>
        </div>
        <div v-if="carregando || carregandoCompra" class="spinner-center"><LoadingSpinner /></div>

        <!-- Tabela de Transações -->
        <template v-else-if="visualizacaoAtiva === 'transacoes'">
          <Paginate
            :total-pages="paginationDataTransacoes.lastPage"
            :current-page="paginationDataTransacoes.currentPage"
            @page-changed="handlePageChange"
          />

          <Table
            :headers="headersTabela"
            :selectable="false"
          >
          <tr v-for="transacao in transacoes" :key="transacao.id" :class="{ 'linha-destaque': transacao.id === transacaoDestaqueId }">
            <td>{{ transacao.data.split(' ')[0].replace(/-/g, '/') }}</td>
            <td>
              <template v-if="transacao.renach || transacao.nosso_numero">
                {{ transacao.renach || transacao.nosso_numero }}
              </template>
              <span
                v-else-if="isConcessao(transacao)"
                class="texto-concessao"
                :title="tooltipConcessao(transacao)"
              >Concessão</span>
            </td>
            <td>
              {{ transacao.nome }}
            </td>
            <td>
              <Badge :text="transacao.tipo.toUpperCase()" :color="transacao.tipo === 'credito' ? 'success' : 'danger'" />
            </td>
            <td class="text-right">{{ transacao.quantidade }} NC</td>
            <td>{{ transacao.descricao.toUpperCase() }}</td>
            <td class="text-right">{{ transacao.saldo }}</td>
          </tr>
          <tr v-if="transacoes.length === 0">
            <td colspan="6" class="text-center text-muted">
              Nenhuma transação encontrada.
            </td>
          </tr>
        </Table>
        </template>

        <!-- Tabela de Concessões (somente financeiro) -->
        <template v-else-if="visualizacaoAtiva === 'concessoes' && isFinanceiro">
          <Paginate
            :total-pages="paginationDataConcessoes.lastPage"
            :current-page="paginationDataConcessoes.currentPage"
            @page-changed="handlePageChange"
          />

          <Table
            :headers="headersTabelaConcessao"
            :selectable="false"
          >
          <tr v-for="concessao in concessoes" :key="concessao.id">
            <td>{{ concessao.date.split(' ')[0].replace(/-/g, '/') }}</td>
            <td>{{ concessao.autoescola || '—' }}</td>
            <td class="text-right">+{{ concessao.quantidade }} NC</td>
            <td class="text-right">{{ concessao.saldo_anterior }} → {{ concessao.saldo }}</td>
            <td>{{ concessao.responsavel || '—' }}</td>
            <td class="motivo-celula" :title="concessao.motivo || null">{{ concessao.motivo || '—' }}</td>
          </tr>
          <tr v-if="concessoes.length === 0">
            <td :colspan="headersTabelaConcessao.length" class="text-center text-muted">
              Nenhuma concessão encontrada.
            </td>
          </tr>
        </Table>
        </template>

        <!-- Tabela de Compras -->
        <template v-else>
          <Paginate
            :total-pages="paginationDataCompras.lastPage"
            :current-page="paginationDataCompras.currentPage"
            @page-changed="handlePageChange"
          />

          <Table
            :headers="headersTabelaCompra"
            :selectable="false"
          >
          <tr v-for="compra in compras" :key="compra.id" :class="{ 'linha-concluida': compra.status === 'concluido' }">
            <td>{{ compra.date.split(' ')[0].replace(/-/g, '/') }}</td>
            <td>
              {{ compra.quantidade }}
            </td>
            <td class="text-right">{{ compra.valor }}</td>
            <td>{{ compra.status.toUpperCase() }}</td>
            <td>
              <div class="d-flex align-items-center gap-2">
                <span style="cursor: pointer; color: blue; text-decoration: underline;">{{ compra.metodo_pagamento.toUpperCase() }}</span>
                <vuestic-dropdown position="bottom" class="perfil-dropdown">
                  <div v-for="boleto in compra.boletos" :key="boleto.id" class="dropdown-boleto-row">
                    <button type="button" @click="copiarChavePix(boleto.receive_data.emv)" class="btn-copiar-pix">
                      Copiar a chave pix
                    </button>
                    <button @click="downloadComprovante(boleto.id)" class="btn-download-boleto">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: middle;"><path d="M.5 9.9a.5.5 0 0 1 .5.5V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.6a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
                    </button>
                    <button @click="gerarQRCode(boleto.receive_data.qrcodeBase64)" class="btn-gerar-qrcode btn-qrcode">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: middle;"><path d="M0 0h7v7H0V0zm1 1v5h5V1H1zm1 1h3v3H2V2zm7-2h7v7H8V0zm1 1v5h5V1H9zm1 1h3v3h-3V2zM0 8h7v7H0V8zm1 1v5h5V9H1zm1 1h3v3H2v-3zm7-2h7v7H8V8zm1 1v5h5V9H9zm1 1h3v3h-3v-3z"/></svg>
                      Gerar QRCode
                    </button>
                  </div>
                </vuestic-dropdown>
              </div>
            </td>
            <td class="text-right">{{ compra.boletos[0].our_number }}</td>
            <td v-if="developerMode">
              <Button
                v-if="developerMode && compra.status !== 'concluido'"
                text="Marcar como pago"
                color="primary"
                size="small"
                @handle:click="pagarCompra(compra.id)"
              />
            </td>
          </tr>
          <tr v-if="compras.length === 0">
            <td colspan="6" class="text-center text-muted">
              Nenhuma compra encontrada.
            </td>
          </tr>
        </Table>
        </template>
      </div>
    </div>
  </PageContainer>
</template>

<script>

import PageContainer from '@/components/core/PageContainer.vue'
import InputDate from '@/components/core/InputDate.vue'
import Select from '@/components/core/Select.vue'
import Input from '@/components/core/Input.vue'
import Button from '@/components/core/Button.vue'
import Table from '@/components/core/Table.vue'
import LoadingSpinner from '@/components/core/LoadingSpinner.vue'
import Badge from '@/components/core/Badge.vue'
import Modal from '@/components/core/Modal.vue'
import Paginate from '@/components/core/Paginate.vue'
import Compras from './Compras.vue'
import ConcederCreditos from './ConcederCreditos.vue'
import urlApi from '@/router/urlApiV2'
import { USER_ROLES, hasRole } from '@/constants/userRoles'
import Accordion from '@/components/core/Accordion.vue'
import DropdownCard from '@/components/core/DropdownCard.vue'
import VuesticDropdown from '@/vuestic-theme/vuestic-components/vuestic-dropdown/VuesticDropdown.vue'
import { abrirQRCode } from '@/services/qrcodeService'

export default {
  name: 'CreditoTransactions',
  components: {
    PageContainer,
    InputDate,
    Select,
    Input,
    Button,
    Table,
    LoadingSpinner,
    Badge,
    Modal,
    Paginate,
    Compras,
    ConcederCreditos,
    Accordion,
    DropdownCard,
    VuesticDropdown
  },
  data () {
    return {
      visualizacaoAtiva: 'transacoes',
      creditosDisponiveis: 150.50, // Simulado; em produção, buscar via API
      transacoes: [], // Array de transações simuladas
      filtros: {
        renach: '',
        dataInicio: '',
        dataFim: '',
        tipo: '',
        descricao: '',
        nossoNumero: '',
      },
      schema: '',
      schemaOptions: [],
      carregando: false,
      headersTabela: ['Data Emissão', 'RENACH / ID Pagamento', 'Nome', 'Tipo', 'Quantidade', 'Descrição', 'Saldo'],
      opcoesTipo: [
        { value: '', text: 'Todos' },
        { value: 'credito', text: 'Entrada' },
        { value: 'debito', text: 'Saída' },
      ],
      headersTabelaCompra: process.env.VUE_APP_ENV === 'development'
        ? ['Data', 'Quantidade', 'Valor', 'Status', 'Forma de Pagamento', 'Nosso Número', 'Ações']
        : ['Data', 'Quantidade', 'Valor', 'Status', 'Forma de Pagamento', 'Nosso Número'],
      // Compra de créditos
      modalCompraAberto: false,
      tiposCreditoOptions: [],
      tipoSelecionado: '',
      quantidade: 1,
      valoresTipos: {},
      carregandoCompra: false,
      saldos: [],
      compras: [],
      developerMode: process.env.VUE_APP_ENV === 'development',
      paginationDataTransacoes: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      paginationDataCompras: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      // Concessão de créditos (somente financeiro)
      concessoes: [],
      headersTabelaConcessao: ['Data', 'Autoescola / Autônomo', 'Quantidade', 'Saldo (antes → depois)', 'Responsável', 'Motivo'],
      paginationDataConcessoes: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      transacaoDestaqueId: null,
      timerDestaque: null,
    }
  },
  computed: {
    valorUnitario () {
      return this.tipoSelecionado ? (this.valoresTipos[this.tipoSelecionado] || 0) : 0
    },
    valorTotal () {
      return this.quantidade > 0 ? this.valorUnitario * this.quantidade : 0
    },
    tipoSelecionadoText () {
      const opt = this.tiposCreditoOptions.find(o => o.value === this.tipoSelecionado)
      return opt ? opt.text : ''
    },
    mostrarSelectAutoescola () {
      const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
      const idFuncao = usuario.id_funcao_usuario
      return idFuncao === 2 || idFuncao === 6
    },
    isFinanceiro () {
      const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
      return hasRole(usuario.id_funcao_usuario, USER_ROLES.FINANCEIRO)
    },
    cfcOptionsConcessao () {
      // remove a opção "Todas" do filtro
      return this.schemaOptions.filter(o => o.value)
    },
    tituloTabela () {
      if (this.visualizacaoAtiva === 'compras') return 'Compras'
      if (this.visualizacaoAtiva === 'concessoes') return 'Concessões de Créditos'
      return 'Transações de Créditos'
    },
  },
  beforeDestroy () {
    clearTimeout(this.timerDestaque)
  },
  async mounted () {
    await this.fetchCfcs()
    this.carregarTransacoes()
    this.carregarSaldo()
  },
  watch: {
    visualizacaoAtiva (novoValor) {
      if (novoValor === 'transacoes' && this.transacoes.length === 0) {
        this.carregarTransacoes()
      } else if (novoValor === 'compras' && this.compras.length === 0) {
        this.carregarCompras()
      } else if (novoValor === 'concessoes' && this.isFinanceiro && this.concessoes.length === 0) {
        this.carregarConcessoes()
      }
    },
    schema () {
      this.transacoes = []
      this.compras = []
      this.concessoes = []
      this.paginationDataConcessoes = {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      }
      this.paginationDataTransacoes = {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      }
      this.paginationDataCompras = {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      }
    }
  },
  methods: {
    async fetchCfcs () {
      if (!this.mostrarSelectAutoescola) return

      try {
        await this.$http
          .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
          .then(res => {
            this.schemaOptions = [{ value: '', text: 'Todas' }]
              .concat(res.body.dados.map(cfc => ({
                value: cfc.tenant_schema,
                text: cfc.nome_fantasia,
              })))
          })
          .catch(error => {
            this.launchToast('fa-exclamation', 'Erro ao carregar autoescolas: ' + ((error.body && error.body.mensagem) || ''))
          })
      } catch (error) {
        this.launchToast('fa-exclamation', 'Erro ao carregar autoescolas.')
      }
    },
    async carregarSaldo () {
      this.loading = true
      try {
        await this.$http.get(`${urlApi}/creditos/saldo`)
          .then((response) => {
            this.saldos = response.body.data
          })
          .catch((err) => {
            this.launchToast('fa-exclamation', err.data.dados || 'Erro ao carregar saldo.')
          })
      } catch (e) {
        this.mensagem = 'Erro ao carregar saldo.'
      } finally {
        this.loading = false
      }
    },
    async carregarTransacoes (page = 1, queryParams = {}) {
      this.carregando = true
      try {
        if (this.mostrarSelectAutoescola && Object.keys(queryParams).length === 0) {
          queryParams.schema = this.schema
        }
        const params = { ...queryParams, page }
        await this.$http.get(`${urlApi}/creditos/transactions`, { params })
          .then((response) => {
            const data = response.body.data
            this.transacoes = data.data.map(transacao => ({
              id: transacao.id,
              data: transacao.date,
              renach: transacao.renach,
              nosso_numero: transacao.nosso_numero,
              nome: transacao.nome,
              tipo: transacao.tipo,
              quantidade: transacao.quantidade_movimentada,
              descricao: transacao.descricao,
              saldo: transacao.saldo,
              // só vêm preenchidos para o financeiro
              motivo: transacao.motivo,
              responsavel: transacao.responsavel,
            }))

            this.paginationDataTransacoes = {
              currentPage: data.current_page,
              lastPage: data.last_page,
              total: data.total,
            }
          })
          .catch((err) => {
            this.launchToast('fa-exclamation', err.data.message)
          })
      } catch (error) {
        // Em produção, exibir modal de erro
      } finally {
        this.carregando = false
      }
    },
    async carregarCompras (page = 1, queryParams = {}) {
      this.carregandoCompra = true
      try {
        if (this.mostrarSelectAutoescola && Object.keys(queryParams).length === 0) {
          queryParams.schema = this.schema
        }
        const params = { ...queryParams, page }
        await this.$http.get(`${urlApi}/creditos/compra`, { params })
          .then((response) => {
            const data = response.body.data
            this.compras = data.data

            this.paginationDataCompras = {
              currentPage: data.current_page,
              lastPage: data.last_page,
              total: data.total,
            }
          })
          .catch((err) => {
            this.launchToast('fa-exclamation', err.data.message)
          })
      } catch (error) {
        // Em produção, exibir modal de erro
      } finally {
        this.carregandoCompra = false
      }
    },
    async carregarConcessoes (page = 1, queryParams = {}) {
      if (!this.isFinanceiro) return
      this.carregando = true
      try {
        if (Object.keys(queryParams).length === 0) {
          queryParams.schema = this.schema
        }
        const params = { ...queryParams, page }
        const response = await this.$http.get(`${urlApi}/creditos/concessao`, { params })
        const data = response.body.data
        this.concessoes = data.data
        this.paginationDataConcessoes = {
          currentPage: data.current_page,
          lastPage: data.last_page,
          total: data.total,
        }
      } catch (err) {
        this.launchToast('fa-exclamation', (err.body && err.body.message) || 'Erro ao carregar concessões.')
      } finally {
        this.carregando = false
      }
    },
    abrirModalConcessao () {
      if (this.$refs.concederCreditos) {
        this.$refs.concederCreditos.iniciar(this.schema)
      }
      if (this.$refs.modalConcessao) {
        this.$refs.modalConcessao.open()
      }
    },
    fecharModalConcessao () {
      if (this.$refs.modalConcessao) {
        this.$refs.modalConcessao.close()
      }
    },
    async onConcessaoRealizada (resultado) {
      this.fecharModalConcessao()
      const qtd = resultado.quantidade
      this.launchToast('fa-check', `${qtd} ${qtd === 1 ? 'crédito concedido' : 'créditos concedidos'} a ${resultado.autoescola}`)

      // mostra o extrato da autoescola que recebeu os créditos, com a nova linha destacada
      this.filtros = {
        renach: '',
        dataInicio: '',
        dataFim: '',
        tipo: '',
        descricao: '',
        nossoNumero: '',
      }
      this.schema = resultado.schema
      this.visualizacaoAtiva = 'transacoes'
      await this.$nextTick()
      await this.carregarTransacoes(1, { schema: resultado.schema })

      clearTimeout(this.timerDestaque)
      this.transacaoDestaqueId = resultado.transacao_id
      this.timerDestaque = setTimeout(() => { this.transacaoDestaqueId = null }, 5000)
    },
    isConcessao (transacao) {
      return (transacao.descricao || '').toLowerCase() === 'concessão de créditos'
    },
    tooltipConcessao (transacao) {
      if (!this.isFinanceiro || (!transacao.responsavel && !transacao.motivo)) return null
      return `Por: ${transacao.responsavel || '—'}\nMotivo: ${transacao.motivo || '—'}`
    },
    abrirModalCompra () {
      this.tipoSelecionado = ''
      this.quantidade = 1
      if (this.$refs.modalCompra && this.$refs.modalCompra.open) {
        this.$refs.modalCompra.open()
      }
    },
    fecharModalCompra () {
      if (this.$refs.modalCompra && this.$refs.modalCompra.close) {
        this.$refs.modalCompra.close()
      }
    },
    onSelecionarTipo (val) {
      this.tipoSelecionado = val
      this.quantidade = 1
    },
    filtrarTransacoes () {
      let payload = {
        periodo_inicial: this.filtros.dataInicio,
        periodo_final: this.filtros.dataFim,
      }

      if (this.visualizacaoAtiva === 'transacoes') {
        payload.renach = this.filtros.renach
        payload.tipo = this.filtros.tipo
      } else if (this.visualizacaoAtiva === 'compras') {
        payload.nosso_numero = this.filtros.nossoNumero
      }

      if (this.mostrarSelectAutoescola) {
        payload.schema = this.schema
      }

      if (this.visualizacaoAtiva === 'transacoes') {
        this.carregarTransacoes(1, payload)
      } else if (this.visualizacaoAtiva === 'concessoes') {
        this.carregarConcessoes(1, payload)
      } else {
        this.carregarCompras(1, payload)
      }
    },
    limparFiltros () {
      this.filtros = {
        renach: '',
        dataInicio: '',
        dataFim: '',
        tipo: '',
        descricao: '',
        nossoNumero: '',
      }
      this.schema = ''
    },
    handlePageChange (page) {
      let payload = {
        periodo_inicial: this.filtros.dataInicio,
        periodo_final: this.filtros.dataFim,
      }

      if (this.visualizacaoAtiva === 'transacoes') {
        payload.renach = this.filtros.renach
        payload.tipo = this.filtros.tipo
      } else if (this.visualizacaoAtiva === 'compras') {
        payload.nosso_numero = this.filtros.nossoNumero
      }

      if (this.mostrarSelectAutoescola) {
        payload.schema = this.schema
      }

      if (this.visualizacaoAtiva === 'transacoes') {
        this.carregarTransacoes(page, payload)
      } else if (this.visualizacaoAtiva === 'concessoes') {
        this.carregarConcessoes(page, payload)
      } else {
        this.carregarCompras(page, payload)
      }
    },
    formatarMoeda (valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(valor)
    },
    formatarData (data) {
      return new Date(data).toLocaleDateString('pt-BR')
    },
    launchToast (icon, msg) {
      this.$toasted.show(msg, {
        icon: icon,
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    async downloadComprovante (id) {
      try {
        const response = await this.$http.get(`${urlApi}/creditos/compra/${id}/download`, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `comprovante_${id}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        let message = error.data && error.data.message ? error.data.message : 'Erro ao baixar comprovante.'
        this.launchToast('fa-exclamation', message)
      }
    },
    async exportarRelatorio (formato) {
      this.launchToast('fa-download', `Exportando relatório em ${formato.toUpperCase()}...`)
      let payload = {
        format: formato,
        renach: this.filtros.renach,
        periodo_inicial: this.filtros.dataInicio,
        periodo_final: this.filtros.dataFim,
        tipo: this.filtros.tipo
      }
      if (this.mostrarSelectAutoescola) {
        payload.schema = this.schema
      }

      try {
        const response = await this.$http.get(
          `${urlApi}/creditos/transactions/export`,
          { params: payload, responseType: 'blob' }
        )
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `relatorio_transacoes.${formato}`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        let message = error.data && error.data.message ? error.data.message : 'Erro ao exportar relatório.'
        this.launchToast('fa-exclamation', message)
      }
    },
    copiarChavePix (chave) {
      if (!chave) return
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(chave)
          .then(() => {
            this.launchToast('fa-check', 'Chave Pix copiada!')
          })
          .catch(() => {
            this.launchToast('fa-exclamation', 'Não foi possível copiar a chave Pix.')
          })
      } else {
        // Fallback para browsers antigos
        const textarea = document.createElement('textarea')
        textarea.value = chave
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.launchToast('fa-check', 'Chave Pix copiada!')
        } catch (err) {
          this.launchToast('fa-exclamation', 'Não foi possível copiar a chave Pix.')
        }
        document.body.removeChild(textarea)
      }
    },
    gerarQRCode (qrcodeBase64) {
      const resultado = abrirQRCode(qrcodeBase64)

      if (!resultado.success) {
        this.launchToast('fa-exclamation', resultado.message)
      }
    },
    pagarCompra (compraId) {
      // Simula o pagamento de uma compra para fins de desenvolvimento
      this.$http.post(`${urlApi}/creditos/compra/${compraId}/pagar`)
        .then(() => {
          this.launchToast('fa-check', 'Compra paga com sucesso (simulado).')
          this.carregarCompras()
          this.carregarSaldo()
        })
        .catch(() => {
          this.launchToast('fa-exclamation', 'Erro ao pagar a compra (simulado).')
        })
    },
    onCompraFinalizada () {
      this.fecharModalCompra()
      this.carregarSaldo()
      this.carregarCompras()
      this.filtrarTransacoes()
    },
  },
}
</script>

<style lang="scss" scoped>
.linha-destaque td {
  animation: destaque-concessao 5s ease-out;
}
@keyframes destaque-concessao {
  0%, 60% { background-color: #d4f5e9; }
  100% { background-color: transparent; }
}
.texto-concessao {
  font-weight: 500;
  color: #1d6b55;
}
.motivo-celula {
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.credito-content {
  width: 100%;
  margin: 0 auto;
  padding: 2rem 1rem 2.5rem 1rem;
}

.filtros-section {
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  padding: 2rem 2rem 1.5rem 2rem;
  margin-bottom: 2rem;
  border: none;
}
.filtros-header {
  gap: 2rem;
  flex-wrap: wrap;
}
.creditos-info {
  min-width: 220px;
  margin-bottom: 0.5rem;
}
.creditos-label {
  font-size: 1.1rem;
  color: #222;
  font-weight: 500;
  margin-bottom: 0.2rem;
}
.creditos-valor {
  font-size: 2.1rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 0.2rem;
}
.creditos-status {
  font-size: 1rem;
  color: #00b69b;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.filtros-actions {
  display: flex;
  gap: 0.5rem;
}
.g-3 > [class^='col-'] {
  margin-bottom: 1rem;
}
.transacoes-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  padding: 2rem 2rem 1.5rem 2rem;
  border: none;
}
.table-responsive {
  margin-top: 1rem;
}
.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 0.5rem 1.2rem;
}
.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 0.5rem 1.2rem;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-muted {
  color: #6c757d;
}
.mb-4 {
  margin-bottom: 1.5rem;
}
.g-3 {
  align-items: center;
  display: flex;
  gap: 1.5rem;
}
.g-3 > [class^='col-'] {
  margin-bottom: 1rem;
  flex: 1 1 0;
}
.ml-2 {
  margin-left: 0.5rem;
}
.export-dropdown {
  margin-left: 0.5rem;
}
.dropdown-export-row {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  padding: 0.5em 0.5em;
}
.btn-export {
  color: #007bff;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1em;
  padding: 0.4em 0.8em;
  border-radius: 4px;
  text-align: left;
  margin-bottom: 0.2em;
  display: flex;
  align-items: center;
}
.card {
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

.linha-concluida {
  background-color: #d4edda;
  color: #155724;
}

.dropdown-boleto-row {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}
.btn-copiar-pix {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.95em;
  padding: 0.2em 0.5em;
  background: none;
  border: none;
  border-radius: 4px 0 0 4px;
}
.btn-download-boleto {
  color: #8b8b8b;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.95em;
  display: flex;
  align-items: center;
  padding: 0.2em 0.5em;
  border-left: 1px solid #e0e0e0;
  border-radius: 0 4px 4px 0;
  margin-left: 0;
}
.btn-gerar-qrcode {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.95em;
  padding: 0.2em 0.5em;
  background: none;
  border: none;
  border-left: 1px solid #e0e0e0;
  border-radius: 0 4px 4px 0;
}
.vuestic-dropdown {
  background: none !important;
}

.spinner-center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  width: 100%;
}

.radio-group {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: #222;

  input[type="radio"] {
    cursor: pointer;
    width: 18px;
    height: 18px;
    accent-color: #007bff;
  }

  span {
    user-select: none;
  }
}
</style>
